import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  INCON_INFO,
  LOGO_DELIVEREE,
  LOGO_TRANSPORTIFY
} from '../../constants/imageConstants'

const _ = window._$g._

const mapStateToProps = (state) => {
  return {
    topLeftMenu: state.topLeftMenu
  }
}

class DefaultHeader extends Component {
  static checkCompareName(name, list) {
    return list.indexOf(name.toLowerCase()) >= 0
  }

  constructor(props) {
    super(props)
    this.state = {
      showInfo: {},
    }
    this.setTimeoutShowInfo = {}
  }

  onClickShowInfo(id) {
    clearTimeout(this.setTimeoutShowInfo[id])
    let showInfo = this.state.showInfo
    if(!showInfo[id]){
      const self = this
      showInfo[id] = true
      this.setState({showInfo}, function(){
        self.setTimeoutShowInfo[id] = setTimeout( function(){self.setState({showInfo: {...self.state.showInfo, [id]: false}})}, 3000 )
      })
    }else{
      this.setState({showInfo: {...this.state.showInfo, [id]: false}})
    }
  }

  renderLeftTopMenu() {
    const { showInfo } = this.state
    const { topLeftMenu } = this.props
    const menus = topLeftMenu['left_top']
    if (_.isUndefined(menus)) {
      return
    }
    return (
      <ul id="menu-intra-city-menu" className="list-item list-item-top">
        {menus.map((menu) => {
          return (
            <li
              key={menu['name']}
              className={`menu-item menu-item-type-post_type menu-item-object-page ${(menu['icon_info'] ? "left-menu-main__info" : '')}`}
            >
              <a href={menu['menu_url']}>
                {menu['name']}
              </a>
              {menu['icon_info'] && <div className="left-menu-i">
                <span onClick={() => this.onClickShowInfo(menu['id'])}>
                  <img src={INCON_INFO} alt="icon info"/>
                </span>
                {showInfo[menu['id']] === true && <div className="left-menu-info">{menu['icon_info']}</div>}
              </div>}
            </li>
          )
        })}
      </ul>
    )
  }

  renderLeftMiddleMenu() {
    const { showInfo } = this.state
    const { topLeftMenu } = this.props
    const menus = topLeftMenu['left_middle']
    if (_.isUndefined(menus)) {
      return
    }
    return (
      <ul id="menu-secondary-menu" className="list-item list-item-bottom">
        {menus.map((menu) => {
          return (
            <li
              key={menu['name']}
              className={`menu-item menu-item-type-post_type menu-item-object-page ${DefaultHeader.checkCompareName(menu['name'], ['ผู้ขับ', 'drivers', 'pengemudi']) ? 'current_page_item' : ''} ${(menu['icon_info'] ? "left-menu-main__info" : '')}`}
            >
              <a href={menu['menu_url']}>
                <span>
                  {menu['name']}
                </span>
              </a>
              {menu['icon_info'] && <div className="left-menu-i">
                <span onClick={() => this.onClickShowInfo(menu['id'])}>
                  <img src={INCON_INFO} alt="icon info"/>
                </span>
                {showInfo[menu['id']] === true && <div className="left-menu-info">{menu['icon_info']}</div>}
              </div>}
            </li>
          )
        })}
      </ul>
    )
  }

  renderLeftBottomMenu() {
    const { topLeftMenu } = this.props
    const menus = topLeftMenu['left_bottom']
    if (_.isUndefined(menus)) {
      return
    }
    const btnMenus = _.filter(menus, item => item['menu_type'] === 'button')
    const iconMenus = _.filter(menus, item => item['menu_type'] === 'icon')
    return (
      <div className="list-button-app">
        {_.map(btnMenus, (menu) => {
          return (
            <button className="btn-launch" key={"button-"+menu['id']}>
              <a href={menu['menu_url']} target="_blank" rel="noopener noreferrer">{menu['name']}</a>
            </button>
          )
        })}
        <div className="btn-list-social">
          <div className="btn-social flex-between">
            {_.map(iconMenus, (menu) => {
              const detectIconInfo = DefaultHeader.checkCompareName(menu['name'], ['info', 'ข้อมูล'])
              return (
                <div className={`btn-social-1 ${detectIconInfo ? 'btn-term' : ''}`} key={"social-"+menu['id']}>
                  {detectIconInfo
                    ? (
                      <a className="flex-center terms-cond" href={menu['menu_url']} target="_blank" rel="noopener noreferrer">
                        <img
                          className="i-term prevent-right-click"
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAkBAMAAACkk32MAAAALVBMVEX///8ArCsArCsArCsArCsArCsArCsArCsArCsArCsArCsArCsArCsArCsArCuhXl4KAAAADnRSTlMAECAwQFBwgI+fr7/P39uux6sAAABlSURBVBiVY2AAAkcGMGCc9+4wmMHz7t07AxAjD8g4AGLsAzIewhhPQIx1QMYDECMOyJgAYnC+e/dGAKw/anchAzZgvRsEGhgY/N6BwAbiGOrl+yAMBoY6ujEgll4vgDoD6FXcDAA2t5RdoKA98AAAAABJRU5ErkJggg=="
                          alt={menu['name']}
                        />
                        <img
                          className="i-term-hover prevent-right-click"
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAkBAMAAACkk32MAAAAKlBMVEX/////2wD/2wD/2wD/2wD/2wD/2wD/2wD/2wD/2wD/2wD/2wD/2wD/2wBdqp8lAAAADXRSTlMAECAwQFBgcICfv9/vqM33ygAAAGRJREFUGJVjYAACIwYI6Lm7DUxz3r17NwHEsAUyDoIYvUDGVRjjBohRC2RcATF0gIwNIAbb3bt3DMD6LVdNYsAGuFaBwAIGBt67IHCBOAZHx1wIg4HBl24MiKU3GqDOAArhZgAA6OiIpo9ovFsAAAAASUVORK5CYII="
                          alt={menu['name']}
                        />
                      </a>
                    ) : (
                      <a className="flex-center" href={menu['menu_url']} target="_blank" rel="noopener noreferrer">
                        <img src={menu['icon_url']} alt={menu['name']} />
                      </a>
                    )
                  }
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
  render() {
    return (
      <div className="app-header">
        <div className="menu menu-type open">
          <div className="menu-type-outside">
            <div className="menu-content">
              <div className="cell-inside expand">
                <div className="cell-inside-1">
                  <div className="item-inside item-logo">
                    <div className="site-branding logo">
                      <a href="https://www.deliveree.com/" className="custom-logo-link" rel="home">
                        <img width="250" height="52" src={window._$g.isTransportify ? LOGO_TRANSPORTIFY : LOGO_DELIVEREE} className="custom-logo" alt="Deliveree Logo" sizes="100vw" />
                      </a>
                    </div>
                  </div>
                  <div className="item-menu list-menu">
                    <nav id="intracity-navigation" className="intracity-navigation top-navigation active" role="navigation" aria-label="Intra City Menu">
                      <div className="menu-intra-city-menu-container">
                        {this.renderLeftTopMenu()}
                      </div>
                    </nav>
                  </div>
                  <div className="btn-menu open-menu" />
                </div>
                <div className="cell-inside-2">
                  <div className="item-menu list-menu">
                    <nav id="secondary-navigation" className="secondary-navigation" role="navigation" aria-label="Secondary Menu">
                      <div className="menu-secondary-menu-container">
                        {this.renderLeftMiddleMenu()}
                      </div>
                    </nav>
                    {this.renderLeftBottomMenu()}
                  </div>
                </div>
              </div>
            </div>
            <div id="button-menu-open" className="menu-trigger collapse">
              <div className="menu-content">
                <div className="triangle open-menu collapse" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(DefaultHeader)
